class ErrorWithCode extends Error {
  code: string;

  constructor(message: string, code: string, options: object = {}) {
    super(message, options);
    this.code = code;
    this.name = 'ErrorWithCode';
  }
}

export default ErrorWithCode;
